/** Extra emails allowed for AI chat / internal features (beyond @sportplatz-media.com). */
const EXTRA_ALLOWED_EMAILS = new Set([
  's@moeller-riepe.de',
  'finja.paape@sportplatz-media.com',
  'nadine-ihde@t-online.de',
]);

/**
 * Internal staff gate used for experimental features (AI chat, debug info).
 * @param {string|null|undefined} email
 * @returns {boolean}
 */
export function isSportplatzMediaEmail(email) {
  if (!email || typeof email !== 'string') {
    return false;
  }
  const normalized = email.toLowerCase().trim();
  return (
    normalized.endsWith('@sportplatz-media.com') ||
    EXTRA_ALLOWED_EMAILS.has(normalized)
  );
}
